// Internal module — consumers should import from './metrics' (barrel) instead.
import { MetricKey, MetricThreshold } from '../model/WeeklyStatisticsResponse';
import { METRICS } from './config';
import { formatNumber } from './formatters';

export interface NormalizedThreshold {
  key: MetricKey;
  thresholdUp: number;
  thresholdDown: number;
}

export type ThresholdMap = Record<MetricKey, NormalizedThreshold>;

export const buildThresholdMap = (thresholds: MetricThreshold[]): ThresholdMap | undefined => {
  const map = Object.fromEntries(
    thresholds.map((t) => [t.key, { key: t.key, thresholdUp: t.thresholdUp, thresholdDown: t.thresholdDown }]),
  ) as Partial<ThresholdMap>;

  const missingKeys = METRICS.filter((m) => !map[m.key]).map((m) => m.key);
  if (missingKeys.length > 0) {
    console.warn(`[Monitoring] Missing thresholds for: ${missingKeys.join(', ')}`);
    return undefined;
  }
  return map as ThresholdMap;
};

export const isAlert = (threshold: NormalizedThreshold, value: number): boolean =>
  value > threshold.thresholdUp || value < threshold.thresholdDown;

export const formatThresholdHint = (threshold: NormalizedThreshold, value: number): string => {
  if (value > threshold.thresholdUp) return ` (> ${formatNumber(threshold.thresholdUp)})`;
  if (value < threshold.thresholdDown) return ` (< ${formatNumber(threshold.thresholdDown)})`;
  return '';
};
